// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"127":"70c9e339","692":"39a4497b","757":"fd0de8d0","949":"70c9e339","961":"fd0de8d0"}[chunkId] + ".css";
};